import { ArrowUpRight } from "lucide-react";
import { ZEFFY_URL } from "@/lib/site";

export default function MobileDonateBar() {
  return (
    <div
      className="fixed inset-x-0 bottom-0 z-40 flex items-center justify-between gap-3 border-t border-ivory/10 bg-forest/95 px-4 py-3 backdrop-blur-md lg:hidden"
      style={{ paddingBottom: "max(0.75rem, env(safe-area-inset-bottom))" }}
      data-testid="mobile-sticky-donate-bar"
    >
      <div className="leading-tight">
        <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-gold">Change for Congo</p>
        <p className="text-xs text-ivory/70">Every contribution counts</p>
      </div>
      <a
        href={ZEFFY_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="mobile-sticky-donate-button"
        className="inline-flex items-center gap-1.5 rounded-full bg-gold px-6 py-3 text-sm font-semibold uppercase tracking-widest text-forest"
      >
        Donate <ArrowUpRight className="h-4 w-4" />
      </a>
    </div>
  );
}
